import React, { useContext } from "react";
import { ConfigContext } from "../../App";
import NextButton from "../elements/NextButton";
import TextButtonGroup from "../TextButtonGroup";
import TextCheckboxButtonGroup from "../TextCheckboxButtonGroup";
import TotalPrice from "../TotalPrice";

import logo from "../../vanchanger_logo_nebelblau.svg";

function Tech() {
	const config = useContext( ConfigContext );

	return <div className="flex configuration-part">
		<div className="flex configuration-part-headline">
			<img className="part-headline-img"
			     src={logo}
			     alt="logo" />
			<h2>Technik</h2>
		</div>



		<TextButtonGroup fullwidth
		                 heading={"Technikpaket"}
		                 name={"tech_package"}
		                 elements={config.tech.techPackage.map( p => p.name )}
		                 featureList={
			                 config.tech.techPackage
			                       .map( c => c.info )
			                       .map( i => <div className="package-summary">
					                       <ul>
						                       {i.map( e => <li>{e.item} </li> )}
					                       </ul>
				                       </div>,
			                       )
		                 }
		/>

		<TextCheckboxButtonGroup
			heading={"Optionale Technikfeatures"}
			name={"tech_optional"}
			elements={config.tech.techOptional.map( t =>t.name)}
            images={config.tech.techOptional.map(g => g.image ? `tech/${g.image}.png` : undefined)}
        />
		<NextButton />

	</div>;
}

export default Tech;
